// Polyfill para Map.prototype.getOrInsertComputed (TC39, disponible desde Chrome 136).
// pdfjs-dist 5.x usa este método; sin el polyfill falla en Chrome <136.
export default defineNuxtPlugin(() => {
  if (typeof Map !== 'undefined' && !Map.prototype.getOrInsertComputed) {
    Object.defineProperty(Map.prototype, 'getOrInsertComputed', {
      configurable: true,
      writable: true,
      value(this: Map<unknown, unknown>, key: unknown, fn: (k: unknown) => unknown) {
        if (this.has(key)) return this.get(key)
        const value = fn(key)
        this.set(key, value)
        return value
      },
    })
  }
})
